import { FC, useState } from "react";
import { useHistory } from "react-router";
import { useQuery } from "../../../utils";
import SearchMedigoProduct from "./SearchMedigoProduct";
import SearchThuocsiProduct from "./SearchThuocsiProduct";

enum SearchTabs {
	medigo = "medigo",
	thuocsi = "thuocsi",
}

const AdminSearchProduct: FC = () => {
	const query = useQuery();
	const tabId: string = query.get("searchTab") || SearchTabs.medigo;
	const [activeTab, setActiveTab] = useState<string>(tabId);
	const history = useHistory();

	const getActiveClass = (tab: SearchTabs) => {
		return activeTab === tab ? "active" : "";
	};
	const getActiveTab = () => {
		switch (activeTab) {
			case SearchTabs.medigo:
				return <SearchMedigoProduct />;
			case SearchTabs.thuocsi:
				return <SearchThuocsiProduct />;
			default:
				<div></div>;
		}
	};

	const onSelectTab = (tab: SearchTabs) => {
		history.push(
			`/admin-dashboard?dashboardTabId=3&searchTab=${tab}`
		);
		setActiveTab(tab);
	};
	return (
		<div style={{ minWidth: "100%" }}>
			<div className="upload-flow">
				<div className="d-flex flex-wrap justify-content-between align-items-center">
					<a
						href="/#"
						onClick={(e) => {
							e.preventDefault();
							onSelectTab(SearchTabs.medigo);
						}}
						className={
							"upload-tab-title mt-3 " +
							getActiveClass(SearchTabs.medigo)
						}
					>
						Sản phẩm Medigo
					</a>
					<a
						href="/#"
						onClick={(e) => {
							e.preventDefault();
							onSelectTab(SearchTabs.thuocsi);
						}}
						className={
							"upload-tab-title mt-3 " +
							getActiveClass(SearchTabs.thuocsi)
						}
					>
						Sản phẩm Thuocsi
					</a>
				</div>
				{getActiveTab()}
			</div>
		</div>
	);
};

export default AdminSearchProduct;
